import * as React from 'react';

interface IAppBannerProps {
    iOSAppId: string;
    androidAppId: string;
    description: string;
}

interface IAppBannerState {
    showAppBanner: boolean;
    closed: boolean;
    isSafari: boolean;
    isAndroid: boolean;
    isIOS: boolean;
}

export class AppBanner extends React.Component<IAppBannerProps, IAppBannerState> {
    constructor(props: IAppBannerProps) {
        super(props);
        this.state = { showAppBanner: false, closed: false, isSafari: false, isAndroid: false, isIOS: false };
    }

    componentDidMount(): void {
        const closedString = localStorage.getItem('appBannerClosed');
        let bannerClosed = false;

        if (closedString !== undefined) {
            const closedTime = new Date(closedString);
            const compareDate = new Date();

            const amountOfDays = Math.round((compareDate.getTime() - closedTime.getTime()) / (1000 * 60 * 60 * 24));

            if (amountOfDays < 31) {
                bannerClosed = true;
            }
        }

        const mobileSystem = this.getMobileOperatingSystem();

        const isIOS = mobileSystem === 'iOS';
        const isAndroid = mobileSystem === 'Android';
        const isSafari = this.isSafari();

        this.setState({ closed: bannerClosed, isIOS, isAndroid, isSafari });
        setTimeout(() => this.setState({ showAppBanner: true }), 30000);
    }

    render(): JSX.Element {
        if (!this.state.showAppBanner || this.state.closed || this.state.isSafari) {
            return null;
        }
        if (!this.state.isAndroid && !this.state.isIOS) {
            return null;
        }

        if (this.state.isIOS && (this.props.iOSAppId === null || this.props.iOSAppId === undefined)) {
            return null;
        }
        if (this.state.isAndroid && (this.props.androidAppId === null || this.props.androidAppId === undefined)) {
            return null;
        }

        return (
            <div className="app-banner d-lg-none">
                <div className="app-banner_close_icon col-1" title="Stäng" onClick={this.close.bind(this)}>
                    <svg className="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <use xlinkHref="#close" />
                    </svg>
                </div>
                <div className="col-2">
                    <img src="/images/app-icon.jpg" alt="App-ikon" className="app-banner-img" />
                </div>
                <div className="col-5 app-banner-description">{this.props.description}</div>
                <div className="col-4">
                    <span className="app-banner-link" onClick={this.closeAndNavigate.bind(this)}>
                        <img
                            className="app-banner-store-icon"
                            alt="App-butiken"
                            src={'/images/' + (this.state.isIOS ? 'app-store-badge.png' : 'google-play-badge.png')}
                        />
                    </span>
                </div>
            </div>
        );
    }

    private close() {
        localStorage.setItem('appBannerClosed', new Date().toDateString());
        this.setState({ closed: true });
    }

    private closeAndNavigate() {
        this.close();

        let appUrl = `https://apps.apple.com/se/app/id${this.props.iOSAppId}`;
        if (!this.state.isIOS) {
            appUrl = `http://play.google.com/store/apps/details?id=${this.props.androidAppId}`;
        }

        window.open(appUrl);
    }

    private isSafari() {
        const isChrome = navigator.userAgent.indexOf('Chrome') > -1 || navigator.userAgent.indexOf('CriOS') > -1;
        let isSafari = navigator.userAgent.indexOf('Safari') > -1;
        if (isChrome && isSafari) {
            isSafari = false;
        }

        return isSafari;
    }

    private getMobileOperatingSystem() {
        const userAgent = navigator.userAgent || navigator.vendor;

        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }

        if (/android/i.test(userAgent)) {
            return 'Android';
        }

        if (/iPad|iPhone|iPod/.test(userAgent) && !window['MSStream']) {
            return 'iOS';
        }

        return 'unknown';
    }
}
